export const setToken = (token) => localStorage.setItem("jwt", token);
export const setFlag = () => localStorage.setItem("onBoarding", true);
export const getToken = () => localStorage.getItem("jwt");
export const removeToken = () => localStorage.removeItem("jwt");
export const getFlag = () => localStorage.getItem("onBoarding");
